import { Button } from "@/components/ui/button.tsx";
import { MessageCircle } from "lucide-react";

/**
 * The way from an artifact back to the conversation that produced it. Offered
 * where an artifact is shown on its own, away from its thread — the Library's
 * lightbox and the standalone artifact page. The in-thread surfaces never need
 * it: the thread is already behind them.
 *
 * Takes a handler rather than a path because where "the thread" opens depends
 * on the host. The Library on the canvas routes a thread through its own opener
 * so the header keeps Search as the way back, which a bare navigation would
 * lose.
 */
export const ArtifactThreadLink = ({ onOpen }: { onOpen: () => void }) => (
  <Button
    type="button"
    variant="ghost"
    size="xs"
    onClick={onOpen}
    className="gap-1.5 text-muted-foreground"
    data-statsig-name="artifact-open-thread"
  >
    <MessageCircle className="size-4" />
    Open thread
  </Button>
);
